<template>
  <div class="project">
    <div class="pb-5">
      <div class="container-fluid px-3 px-md-2">
        <ul class="menu d-flex justify-content-center">
          <li v-for="(item,index) in menus" :key="index" @click="getList(item.type,index)"><router-link :to="{path:'/projects/'+ item.type}" class="py-4" :class="{'cur':index == curType}" >{{item.name}}</router-link></li>
        </ul>
        <ul class="row row-cols-1 row-cols-md-2 row-cols-xxl-3 g-3 g-md-2 indexPro">
          <li class="col" v-for="(item,index) in lists" :key="index">
            <router-link :to="{path: '/projects/detail/' + item.id, query: {type: curType}}" class="d-block">
              <!-- @click="showDetail(item.picture,item.video)" -->
              <div class="pic h-100 overflow-hidden"><img :src="item.poster" class="w-100 h-100 object-fit-cover time05"></div>
              <div class="mask time05"></div>
              <dl class="text mb-0 px-3 px-lg-4">
                <dt>{{item.cntitle}}<span class="ps-2">{{item.place}}</span></dt>
                <dd class="mb-0">{{item.title}}</dd>
              </dl>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <!-- <PicDetail :pic='selectPic' :video='selectVideo' ref="picModalView"/> -->
  </div>
</template>

<script>
import axios from '@/axios-auth'
// import PicDetail from '@/components/picDetail'

export default {
  name: 'Project',
  // components:{
  //   PicDetail,
  // },

  data () {
    return {
      projects:[],
      menus:[],
      lists:[],
      state:0,
      selectPic:[],
      selectVideo:[],
      curType:this.$route.params.id
    }
  },
  computed: {
   
  },
  created(){
    axios.get('/projects.json')
        .then( res => {
          return res.data
        })
        .then( response => {
          if(response.code == 0){
            this.projects = response.data
            // this.types = response.data.name
            this.lists = this.projects[this.curType].list.reverse()
            this.projects.forEach((project) => {
              this.menus.push(project.menu)
            })
          
          }
        })
  },
  methods:{
    getList(type,index){
      this.lists = this.projects[type].list
      this.curType = index
    },
    showDetail(pic,video){
      this.selectPic = pic
      this.selectVideo = video
      this.$refs.picModalView.showView()
      this.$refs.picModalView.swiperUpdate()
    }
  },
  mounted(){
    this.$nextTick(function(){

    })
  }
  
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .indexPro li a{ position: relative; height: 250px;}
  .indexPro .text{ position: absolute; left: 0; right: 0; bottom: 15px; color: #fff;}
  .indexPro dt{ font-size: 14px; font-weight: normal;}
  .indexPro dd{ font-size: 12px;}
  .indexPro .mask{ background-color: rgba(0, 0, 0, .3); position: absolute; left: 50%; top: 50%; transform: translateX(-50%) translateY(-50%); width: 100%; height: 100%;}

  @media (min-width: 576px) {
    .indexPro li a{ height: 350px;}
  }

  @media (min-width: 768px) {

  }

  @media (min-width: 992px) {
    

    .indexPro li a{ height: 450px;}
    .indexPro .text{ bottom: 30px;}
    .indexPro li a:hover .mask{ opacity: 0;}
    .indexPro li a:hover img{transform:scale(1.05) ;}
  }

  @media (min-width: 1200px) {

  }

  @media (min-width: 1400px) {
    .indexPro li a{ height: 500px; }
    .indexPro dt{ font-size: 18px;}
    .indexPro dd{ font-size: 18px;}
  }
</style>



// WEBPACK FOOTER //
// src/components/projects/Projects.vue